export default class Menu {
    constructor() {
        this.hamburger = document.querySelector('.hamburger');
        if (!this.hamburger) return;

        this.hamburger.addEventListener('click', this.toggleMenu.bind(this));
    }

    toggleMenu() {
        document.body.classList.toggle('menu-open');
        this.hamburger.classList.toggle('is-active');
        document.querySelector('.navbar__inner').classList.toggle('open');
    }
}